export interface JobRecommendationCategoriesActions {
    jobId: number;
    actionId: number;
    actionType: ActionType;
    categoryName: string;
    description: string;
    recommendAction: boolean;
    isCustomAction: boolean;
    createdBy: string;
    actionCreatedDateUtc: string;
}

export enum ActionType {
    Todo,
    Completed,
    Dismissed
}
